import { useGeneratedPricingCustomerListDataQuery } from '@sales-portal/domain/pricing/screens/customers/blocs/documents/customer-list-data.generated';
import { useMemo } from 'react';

export const useCustomerListDataLoader = () => {
  const { data, loading, error, refetch } =
    useGeneratedPricingCustomerListDataQuery({
      notifyOnNetworkStatusChange: true,
    });

  return useMemo(
    () => ({
      data,
      error,
      loading,
      refetch,
    }),
    [data, error, loading, refetch],
  );
};
